<template>
    <v-container fluid>
        <mainDashBoard></mainDashBoard>
    </v-container>
</template>

<script>
    const welcomeStepper = ()=> import( '@/components/orgApps/WelcomeUserOrg/WelcomeStepper');
    const mainDashBoard = ()=> import( '@/components/orgApps/OrgMainDashBoard');

    export default {
        name: "workSpace",
        components:{
            welcomeStepper, mainDashBoard
        }
    }
</script>

<style scoped>

</style>